<template>
  <section class="container">
    <div class="head">
      <h1>Link Report</h1>
      <div
        class="export-btn">
        <v-button
          type="plain"
          size="mini"
          :disabled="isDisable"
          @click="handlerDown"
        >Export Excel
        </v-button>
      </div>
      <div class="filter-card">
        <div class="form-item">
          <span>Date</span>
          <v-date-picker
            v-model="date"
            type="daterange"
            @change="filterData" />
        </div>
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          width="150px"
          label="Created">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <span>{{ row.created_date.split(" ")[0]}}</span><br>
              <span> {{ row.created_date.split(" ")[1]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="link"
          label="URL">
        </el-table-column>
        <el-table-column
          prop="host"
          label="Host">
        </el-table-column>
        <el-table-column
          prop="path"
          label="Path">
        </el-table-column>
        <el-table-column
          prop="query"
          label="Query">
        </el-table-column>
        <el-table-column
          prop="referrer"
          label="Referer">
        </el-table-column>
      </el-table>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import { getLinkList, exportLinkList } from '@/api/link-report'
import {downloadFile} from '@/utils/download'
export default {
  name: '',
  data () {
    return {
      date: [],
      tableData: [],
      pageConfig:{
        total: 0,
        currentPage: 1
      }
    }
  },
  computed:{
    isDisable(){
      return this.date.length == 0
    }
  },
  created(){
    this.network().getList()
  },
  methods: {
    handlerDown(){
      this.network().exportLinkList()
    },

    filterData(){
      this.network().getList()
    },

    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getList()
    },

    network(){
      return{
        getList: async() => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage
          }
          const { data } = await getLinkList(params)
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.pageConfig.currentPage = data.current_page
        },
        exportLinkList: async() => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1]
          }
          const res = await exportLinkList(params)
          downloadFile(res)
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
  .container{
    position: relative;
    .head{
      .export-btn{
        position: absolute;
        top: 10px;
        right: 0;
      }
      .filter-card{
        margin-bottom: 15px;
        background: white;
        border: 1px solid #E1E4E8;
        border-radius: 5px;
        padding: 15px;
        .form-item{
          width: 300px;
        }
      }
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        padding: 10px 15px!important;
        vertical-align: top;
        margin-right: 15px;
      .cell{
        line-height: 18px;
        position: relative;
        height: inherit;
        padding: 0;
      }
      }
    }
    .table-pointer{
      cursor: pointer;
    }
  }
</style>
